import React, { useEffect, useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation } from 'react-router-dom';

import AppTopbar from './AppTopbar';
import AppBreadcrumb from './AppBreadcrumb';

import AppFooter from './AppFooter';
import AppMenu from './AppMenu';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import Bitacora from './components/Bitacora/Bitacora';
import Operador from './components/Operador/Operador';
import MisAlertas from './components/Alertas/MisAlertas';
import AdminSuscripciones from './components/Alertas/AdminSuscripciones';
import ConsultaAlertas from './components/Alertas/ConsultaAlertas';
import AlertasSeguridad from './components/Alertas/AlertasSeguridad';
import SeguridadUsuarios from './seguridad/SeguridadUsuarios';
import SeguridadPoliticas from './seguridad/SeguridadPoliticas';
import SeguridadBitacora from './seguridad/SeguridadBitacora';
import DispositivosMaestro from './seguridad/DispositivosMaestro';
import PoliSolicitudes from './poligrafia/PoliSolicitudes';
import PoliAsignacion from './poligrafia/PoliAsignacion';
import PoliRecepcion from './poligrafia/PoliRecepcion';
import PoliCompanias from './poligrafia/PoliCompanias';
import PoliConfiguracion from './poligrafia/PoliConfiguracion';
import PoliRegistro from './poligrafia/PoliRegistro';
import PoliCalendario from './poligrafia/PoliCalendario';
import PoliPanel from './poligrafia/PoliPanel';
import PoliEstadisticas from './poligrafia/PoliEstadisticas';
import PoliFinanciero from './poligrafia/PoliFinanciero';
import TableroAlertas from './components/Alertas/TableroAlertas';
import AuditoriaLectura from './components/Alertas/AuditoriaLectura';
import DashboardAlarmasGps from './components/DashboardAlarmasGps/DashboardAlarmasGps';
import Supervisor from './components/Supervisor/Supervisor';
import Ubicaciones from './components/Maestro/Ubicaciones';
import { useLocalState } from './util/useLocalStorage';
import PrivateRouteOperador from './components/RutasPrivadas/PrivateRouteOperador';
import PrivateRouteSupervisor from './components/RutasPrivadas/PrivateRouteSupervisor';
import PrivateRouteUbicaciones from './components/RutasPrivadas/PrivateRouteUbicaciones';
import PrivateRouteGuardiaPatio from './components/RutasPrivadas/PrivateRouteGuardiaPatio';
import PrivateRouteWhatsapp from './components/RutasPrivadas/PrivateRouteWhatsapp';
import Whatsapp from './components/Whatsapp/Whastapp';
import Logistica from './components/Logistica/Logistica';

import { GMapDemo } from './components/GoogleMaps/GMapsDemo';
import Ruta from './components/Maestro/Ruta';
import Booking from './components/Booking/Booking';
import ListaViajesActivos from './components/Viajes/ViajesActivos';
import MonitorCom from './components/MonitorCom/MonitorCom';
import PrivateRouteAjusteHorario from './components/RutasPrivadas/PrivateRouteAjusteHorario';
import PrivateRouteConfigFrecuencia from './components/RutasPrivadas/PrivateRouteConfigFrecuencia';
import PrivateRouteUtilAdmin from './components/RutasPrivadas/PrivateRouteUtilAdmin';
import PrivateRouteAdminHorario from './components/RutasPrivadas/PrivateRouteAdminHorario';
import PrivateRouteReporteMonitor from './components/RutasPrivadas/PrivateRouteReporteMonitor';
import PrivateRouteInfoGeofences from './components/RutasPrivadas/PrivateRouteInfoGeofences';
import PrivateRoutePuestoTemp from './components/RutasPrivadas/PrivateRoutePuestoTemp';
import PrivateRouteInfoPuesto from './components/RutasPrivadas/PrivateRouteInfoPuesto';

import PrivateRouteDatosEmpleados from './components/RutasPrivadas/PrivateRouteDatosEmpleados';
import DatosEmpleados from './components/DatosEmpleado/DatosEmpleados';

import AjusteHorario from './components/AjusteHorario/AjusteHorario';
import AdminHorario from './components/AdminHorario/AdminHorario';
import ConfigFrecuencia from './components/ConfigFrecuencia/ConfigFrecuencia';
import ReporteMonitor from './components/ReporteMonitor/ReporteMonitor';
import InfoGeofences from './components/InfoGeofences/InfoGeofences';
import Utiladmin from './components/UtilAdmin/UtilAdmin';
import PuestoTemp from './components/PuestoTemp/PuestoTemp';
import InfoPuesto from './components/InfoPuesto/InfoPuesto';
import Custodia from './components/Custodia/Custodia';
import AsignaRoles from './components/AsignaRoles/AsignaRoles';
import PermisosRoles from './components/PermisosRoles/PermisosRoles';
import ConfiguraDet from './components/ConfiguraDet/ConfiguraDet';
import AdminSiniestro from './components/Siniestros/AdminSiniestro';
import UbicacionSiniestro from './components/Siniestros/UbicacionSiniestro';
import ReporteEventosPosiciones from './components/ReporteEventosPosiciones/ReporteEventosPosiciones';
import ReporteDispositivos from './components/ReporteDispositivos/ReporteDispositivos';
import MaestrosDole from './components/Maestro/MaestrosDole';
import DirectorioPuestos from './components/DirectorioPuestos/DirectorioPuestos';
import { getPantallasByUsuarioId } from './services/Roles/RolesService';

export const RTLContext = React.createContext();

const componenteMap = {
    MisAlertas: MisAlertas,
    AdminSuscripciones: AdminSuscripciones,
    ConsultaAlertas: ConsultaAlertas,
    AlertasSeguridad: AlertasSeguridad,
    SeguridadUsuarios: SeguridadUsuarios,
    SeguridadPoliticas: SeguridadPoliticas,
    SeguridadBitacora: SeguridadBitacora,
    DispositivosMaestro: DispositivosMaestro,
    PoliSolicitudes: PoliSolicitudes,
    PoliAsignacion: PoliAsignacion,
    PoliRecepcion: PoliRecepcion,
    PoliCompanias: PoliCompanias,
    PoliConfiguracion: PoliConfiguracion,
    PoliRegistro: PoliRegistro,
    PoliCalendario: PoliCalendario,
    PoliPanel: PoliPanel,
    PoliEstadisticas: PoliEstadisticas,
    PoliFinanciero: PoliFinanciero,
    TableroAlertas: TableroAlertas,
    AuditoriaLectura: AuditoriaLectura,
    Bitacora: Bitacora,
    Operador: Operador,
    DashboardAlarmasGps: DashboardAlarmasGps,
    MonitorCom: MonitorCom,
    AjusteHorario: AjusteHorario,
    Supervisor: Supervisor,
    Ubicaciones: Ubicaciones,
    Logistica: Logistica,
    Ruta: Ruta,
    Booking: Booking,
    AdminHorario: AdminHorario,
    ConfigFrecuencia: ConfigFrecuencia,
    ReporteMonitor: ReporteMonitor,
    InfoGeofences: InfoGeofences,
    Utiladmin: Utiladmin,
    PuestoTemp: PuestoTemp,
    InfoPuesto: InfoPuesto,
    ListaViajesActivos: ListaViajesActivos,
    AsignaRoles: AsignaRoles,
    PermisosRoles: PermisosRoles,
    ConfiguraDet: ConfiguraDet,
    DatosEmpleados: DatosEmpleados,
    Custodia: Custodia,
    AdminSiniestro: AdminSiniestro,
    UbicacionSiniestro: UbicacionSiniestro,
    ReporteEventosPosiciones: ReporteEventosPosiciones,
    ReporteDispositivos: ReporteDispositivos,
    MaestrosDole: MaestrosDole,
    DirectorioPuestos: DirectorioPuestos
};

const App = () => {
    const [menuMode] = useState('static');
    const [inlineMenuPosition] = useState('bottom');
    const [desktopMenuActive, setDesktopMenuActive] = useState(true);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [colorMode, setColorMode] = useState('light');
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('filled');
    const [isRTL] = useState(false);
    const [ripple] = useState(true);
    const [mobileTopbarActive, setMobileTopbarActive] = useState(false);
    const [menuTheme, setMenuTheme] = useState('light');
    const [topbarTheme, setTopbarTheme] = useState('blue');
    const [isInputBackgroundChanged, setIsInputBackgroundChanged] = useState(false);
    const [inlineMenuActive, setInlineMenuActive] = useState({});
    // const [setNewThemeLoaded] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const copyTooltipRef = useRef();
    let currentInlineMenuKey = useRef(null);
    const location = useLocation();
    const [menu, setMenu] = useState([]);
    const [routes, setRoutes] = useState([]);

    PrimeReact.ripple = true;

    let searchClick;
    let topbarItemClick;
    let menuClick;
    let inlineMenuClick;

    const [roles, setRoles] = useLocalState('', 'roles');
    const [pantallas, setPantallas] = useState([]);

    useEffect(() => {
        const recuperaPantallas = async () => {
            const usuario = localStorage.getItem('userId');
            try {
                // Rol DOLE-ANDEN: acceso restringido -> no ve el Dashboard, solo lo que le den las pantallas.
                let esAnden = false;
                try { esAnden = (JSON.parse(localStorage.getItem('roles')) || []).includes('DOLE-ANDEN'); } catch (e) { esAnden = false; }
                let _menu = [
                    {
                        label: 'Menu',
                        icon: 'pi pi-fw pi-home',
                        items: esAnden ? [] : [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
                    }
                ];

                let _routes = [{ path: '/', parent: '', label: '' }];

                const response = await getPantallasByUsuarioId(usuario);
                setPantallas(response);
                // Guardamos el detalle de pantallas con permisos otorgados en localStorage
                // para que cualquier componente pueda consultar sus bloques habilitados.
                try { localStorage.setItem('pantallas', JSON.stringify(response || [])); } catch (e) { /* noop */ }
                //creando la estructura
                response.forEach((item) => {
                    const itemMenu = {
                        label: item.label,
                        icon: `pi pi-fw ${item.icon}`,
                        to: item.dirUrl
                    };
                    _menu[0].items.push(itemMenu);
                    const itemRoute = {
                        path: item.path,
                        parent: item.parent,
                        label: item.label
                    };
                    _routes.push(itemRoute);
                    //console.log('000', itemMenu);
                });
                ///return response
                // Actualizar el estado del menú y rutas
                setMenu(_menu);
                setRoutes(_routes);
            } catch (err) {
                //setError (err.message)
                // esto manda manejo de error al nivel superior de llamada
                //throw err;
                console.error('Fallo en la operacion de Pantallas: ', err.message);
            } finally {
                //setLoading(true)
            }
        };
        recuperaPantallas();
    }, []);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        if (menuMode === 'overlay') {
            hideOverlayMenu();
        }
        if (menuMode === 'static') {
            setDesktopMenuActive(true);
        }
    }, [menuMode]);

    useEffect(() => {
        onColorModeChange(colorMode);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const appLogoLink = document.getElementById('app-logo');

        if (topbarTheme === 'white' || topbarTheme === 'yellow' || topbarTheme === 'amber' || topbarTheme === 'orange' || topbarTheme === 'lime') {
            appLogoLink.src = 'assets/layout/images/Logo_Cema.png';
        } else {
            appLogoLink.src = 'assets/layout/images/Logo_Cema.png';
        }
    }, [topbarTheme]);

    const onColorModeChange = (mode) => {
        setColorMode(mode);
        setIsInputBackgroundChanged(true);

        if (isInputBackgroundChanged) {
            if (mode === 'dark') {
                setInputStyle('filled');
            } else {
                setInputStyle('outlined');
            }
        }

        if (mode === 'dark') {
            setMenuTheme('dark');
            setTopbarTheme('dark');
        } else {
            setMenuTheme('light');
            setTopbarTheme('blue');
        }

        const layoutLink = document.getElementById('layout-css');
        const layoutHref = 'assets/layout/css/layout-' + mode + '.css';
        replaceLink(layoutLink, layoutHref);

        const themeLink = document.getElementById('theme-css');
        const urlTokens = themeLink.getAttribute('href').split('/');
        urlTokens[urlTokens.length - 1] = 'theme-' + mode + '.css';
    };

    const replaceLink = (linkElement, href, callback) => {
        if (isIE()) {
            linkElement.setAttribute('href', href);

            if (callback) {
                callback();
            }
        } else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                const _linkElement = document.getElementById(id);
                _linkElement && _linkElement.remove();
                cloneLinkElement.setAttribute('id', id);

                if (callback) {
                    callback();
                }
            });
        }
    };

    const onMenuClick = (event) => {
        menuClick = true;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isDesktop()) setDesktopMenuActive((prevState) => !prevState);
        else setMobileMenuActive((prevState) => !prevState);

        event.preventDefault();
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        if (activeTopbarItem === event.item) setActiveTopbarItem(null);
        else {
            setActiveTopbarItem(event.item);
        }

        event.originalEvent.preventDefault();
    };

    const onSearch = (event) => {
        searchClick = true;
        setSearchActive(event);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items && (menuMode === 'overlay' || !isDesktop())) {
            hideOverlayMenu();
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const onRootMenuItemClick = (event) => {
        setMenuActive((prevState) => !prevState);
    };

    const onRightMenuButtonClick = () => {
        setRightMenuActive((prevState) => !prevState);
    };

    const onMobileTopbarButtonClick = (event) => {
        setMobileTopbarActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onDocumentClick = (event) => {
        if (!searchClick && event.target.localName !== 'input') {
            setSearchActive(false);
        }

        if (!topbarItemClick) {
            setActiveTopbarItem(null);
        }

        if (!menuClick && (menuMode === 'overlay' || !isDesktop())) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }
            hideOverlayMenu();
        }

        if (inlineMenuActive[currentInlineMenuKey.current] && !inlineMenuClick) {
            let menuKeys = { ...inlineMenuActive };
            menuKeys[currentInlineMenuKey.current] = false;
            setInlineMenuActive(menuKeys);
        }

        if (!menuClick && (isSlim() || isHorizontal())) {
            setMenuActive(false);
        }

        searchClick = false;
        topbarItemClick = false;
        inlineMenuClick = false;
        menuClick = false;
    };

    const hideOverlayMenu = () => {
        setMobileMenuActive(false);
        setDesktopMenuActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 1024;
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isIE = () => {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    };

    const layoutContainerClassName = classNames('layout-wrapper ', 'layout-menu-' + menuTheme + ' layout-topbar-' + topbarTheme, {
        'layout-menu-static': menuMode === 'static',
        'layout-menu-overlay': menuMode === 'overlay',
        'layout-menu-slim': menuMode === 'slim',
        'layout-menu-horizontal': menuMode === 'horizontal',
        'layout-menu-active': desktopMenuActive,
        'layout-menu-mobile-active': mobileMenuActive,
        'layout-topbar-mobile-active': mobileTopbarActive,
        'layout-rightmenu-active': rightMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': !ripple,
        'layout-rtl': isRTL
    });

    return (
        <RTLContext.Provider value={isRTL}>
            <div className={layoutContainerClassName} onClick={onDocumentClick}>
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

                <AppTopbar
                    horizontal={isHorizontal()}
                    activeTopbarItem={activeTopbarItem}
                    onMenuButtonClick={onMenuButtonClick}
                    onTopbarItemClick={onTopbarItemClick}
                    onRightMenuButtonClick={onRightMenuButtonClick}
                    onMobileTopbarButtonClick={onMobileTopbarButtonClick}
                    mobileTopbarActive={mobileTopbarActive}
                    searchActive={searchActive}
                    onSearch={onSearch}
                />

                <div className="menu-wrapper" onClick={onMenuClick}>
                    <div className="layout-menu-container">
                        {inlineMenuPosition === 'top' || inlineMenuPosition === 'both'}
                        <AppMenu model={menu} onMenuItemClick={onMenuItemClick} onRootMenuItemClick={onRootMenuItemClick} menuMode={menuMode} active={menuActive} />
                        {inlineMenuPosition === 'bottom' || inlineMenuPosition === 'both'}
                    </div>
                </div>

                <div className="layout-main">
                    <AppBreadcrumb routes={routes} />

                    <div className="layout-content">
                        <Routes>
                            {pantallas.map((item, index) => {
                                const ComponenteActual = componenteMap[item.componente];
                                if (!ComponenteActual) {
                                    console.error(`Componente para clave ${item.componente} no existe`);
                                    return null;
                                }
                                return <Route key={index} path={item.dirUrl} element={<ComponenteActual />} />;
                            })}
                        </Routes>
                    </div>

                    <AppFooter colorMode={colorMode} />
                </div>

                {mobileMenuActive && <div className="layout-mask modal-in"></div>}
            </div>
        </RTLContext.Provider>
    );
};

export default App;
